import { render, staticRenderFns } from "./VisitorBlacklist.vue?vue&type=template&id=79c87a88&scoped=true"
import script from "./VisitorBlacklist.vue?vue&type=script&lang=js"
export * from "./VisitorBlacklist.vue?vue&type=script&lang=js"
import style0 from "./VisitorBlacklist.vue?vue&type=style&index=0&id=79c87a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c87a88",
  null
  
)

export default component.exports